import Raven from 'raven-js';
import { CreateViewModal } from '../../createView/components/CreateViewModal';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultPinnedViewsBarCreateViewModal = props => {
  return /*#__PURE__*/_jsx(CreateViewModal, {
    viewId: "all" // we want to clone the "all" view to create a new one from a scratch starting point
    ,
    namespaceName: props.namespace,
    objectTypeId: props.objectTypeId,
    onClose: props.onClose,
    strategy: "CREATE_NEW",
    onSuccess: ({
      createdView
    }) => {
      props.onCreate(createdView.id);
    },
    onFailure: e => {
      //the modal internally handles showing an error message
      Raven.captureException(e);
    }
  });
};